import axios from 'axios'

export class OwalBaseAPI {
  constructor (prodUri, debugUri, debug = false, qa = false) {
    this.prodUri = prodUri
    this.debugUri = debugUri
    this.debug = debug
    this.qa = qa
  }

  setDebug (debug = true) {
    this.debug = debug
  }

  setQA (qa = true) {
    this.qa = qa
  }

  delete (path, params) {
    params = params || ''
    return axios.delete(`${this.getBaseUri()}${path}`, { data: params })
  }

  get (path, params) {
    params = params || ''
    return axios.get(`${this.getBaseUri()}${path}${params || ''}`)
  }

  getImage (path, params) {
    params = params || ''
    const axiosReq = axios({
      url: `${this.getBaseUri()}${path}${params || ''}`,
      method: 'GET',
      responseType: 'arraybuffer',
      headers: {
        'Accept': 'image/jpeg',
      },
    })
    return axiosReq
  }

  download (path, params, data) {
    params = params || ''
    data = data || {}
    // console.log(path)
    return axios({
      url: `${this.getBaseUri()}${path}${params}`,
      method: 'POST',
      responseType: 'blob',
      data: data,
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      // console.log(response.headers['content-disposition'])
      const fileNameHeader = response.headers['content-disposition'].match(/filename=/)
      const fileName = response.headers['content-disposition'].slice(fileNameHeader.index + 10, response.headers['content-disposition'].length - 1)

      link.setAttribute('download', `${fileNameHeader ? fileName : 'activity-report.pdf'}`)
      document.body.appendChild(link)
      link.click()
    })
  }

  patch (path, params) {
    params = params || {}
    params.token = axios.defaults.headers.common.authorization
    return axios.patch(`${this.getBaseUri()}${path}`, params)
  }

  put (path, params) {
    params = params || {}
    params.token = axios.defaults.headers.common.authorization
    return axios.put(`${this.getBaseUri()}${path}`, params)
  }

  post (path, params) {
    params = params || {}
    params.token = axios.defaults.headers.common.authorization
    return axios.post(`${this.getBaseUri()}${path}`, params)
  }

  getBaseUri () {
    if (this.debug) {
      return this.debugUri
    } else if (this.qa) {
      return `${this.prodUri.slice(0, 7)}qa.${this.prodUri.slice(8)}`
    }
    return this.prodUri
  }
}

export const SVC_A = new OwalBaseAPI(process.env.VUE_APP_OWAL_SVC_A_URI, 'http://localhost:3030')
export const SVC_C = new OwalBaseAPI(process.env.VUE_APP_OWAL_SVC_C_URI, 'https://yakov.owal.io')
export const SVC_C_RT = new OwalBaseAPI(process.env.VUE_APP_OWAL_SVC_C_RT_URI, 'https://yakov.owal.io')
export const SVC_D = new OwalBaseAPI(process.env.VUE_APP_OWAL_SVC_D_URI, 'http://localhost:60004')
export const SVC_H = new OwalBaseAPI('https://svc-h.api.owal.io', 'svc_h localhost is not set up')
